// extracted by mini-css-extract-plugin
var _1 = "PurchaseSummaryStyle-module__currency___H7skE";
var _2 = "PurchaseSummaryStyle-module__highlighted___n6Prr";
export { _1 as "currency", _2 as "highlighted" }
